var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"header-content"},[_c('div',{staticClass:"back-btn",on:{"click":_vm.toBack}},[_c('i',{staticClass:"el-icon-arrow-left"}),_c('span',[_vm._v("返回")])]),_c('div',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }